<template lang="pug">
    model-form(
        ref='form'
        submit-text='guardar'
        title='Crear contrato'
        v-bind='formProps'
        v-model='formData'
        @reset='reset'
        @submit='submit'
    )
        template( slot='header-actions' )
            model-autocomplete(
                chips
                hide-details
                item-text='structure_name'
                item-value='id'
                label='Seleccionar tipo de contrato'
                single-line              
                solo
                v-bind='autocompleteProps'
                v-model='autocompleteData'
                style='margin: -12px 0 -12px auto; width: 300px;'
            )
</template>

<script>
    //
    import { mapActions, mapState } from 'vuex'
    import { ModelAutocomplete, ModelForm } from '@/components/reusable_components/next'
    import TranslatorService from '@/services/translator'
    //
    import ContractModel from '@/models/HumanResource/HrContract'
    import ContractStructureModel from '@/models/HumanResource/HrContractStructure'
    import ContractFields from '@/views/HumanResource/HrContract/partials/HrContractFieldsCreate'
    //
    export default {
        name: 'contract-create',
        components: {
            ModelAutocomplete,
            ModelForm,
        },
        computed: {

            /**
             * 
             */
            ...mapState('SnackbarModalModule', ['responseConfirm']),

            /**
             *
             */
            autocompleteProps() {
                return {
                    model: ContractStructureModel,
                    outline: false,
                }
            },

            /**
             *
             */
            formProps() {
                return {
                    fields: ContractFields,
                }
            }
        },
        data() {
            return {
                autocompleteData: {},
                formData: new ContractModel({
                    base_salary: 0,
                    collation: 0,
                    hr_contract_period_id: 1,
                    hr_contract_type_id: 2,
                    mobilization: 0,
                    weekly_hours: 0,
                    selected: [],
                }),
            }
        },
        methods: {

            /**
             * 
             */
            ...mapActions('MenuesModule', [
                'setTitleTopBar',
            ]),

            /**
             * 
             */
            ...mapActions('SnackbarModalModule', [
                'setErrorSnackbar',
                'setSuccessSnackbar',
                'setWarningSnackbar',
            ]),

            /**
             *
             */
            error(error) {
                this.setErrorSnackbar(TranslatorService(ContractModel, error.response.data))
            },

            /**
             *
             */
            redirect() {
                this.$router.push({ name: 'contract-list' })
            },

            /**
             * 
             */
            reset() {
                this.formData.base_salary = 0
                this.formData.collation = 0
                this.formData.hr_contract_period_id = 1
                this.formData.hr_contract_type_id = 1
                this.formData.employee_id = 0
                this.formData.mobilization = 0
                this.formData.weekly_hours = 0
            },

            /**
             * 
             */
            submit() {
                this.$refs.form.setWait(true).then(this.toCreate).then(this.$refs.form.setWait)
            },

            /**
             * 
             */
            success() {
                this.setSuccessSnackbar('Contrato agregado exitosamente.')
            },

            /**
             *
             */
            toCreate(model) {
                return model
                    .toCreate()
                    .save()
                    .then(this.success)
                    .then(this.redirect)
                    .catch(this.error)
            },
        },
        mounted() {
            this.setTitleTopBar('Crear contrato')
            this.reset()
        },
        watch: {

            /**
             * 
             */
            autocompleteData(val) {
                this.formData.base_salary = val.base_salary
                this.formData.collation = val.collation
                this.formData.hr_contract_period_id = val.hr_contract_period_id
                this.formData.hr_contract_type_id = val.hr_contract_type_id
                this.formData.mobilization = val.mobilization
                this.formData.weekly_hours = val.weekly_hours
            },

            'formData.hr_contract_type_id'(val) {

                // set readonly end input
                ContractFields[9].props = {
                    ...ContractFields[9].props,
                    pickerProps: {
                        ...ContractFields[9].props.pickerProps,
                        readonly: val === 1,
                    }
                }
            },
        }
    }
</script>